import React, { memo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';

function Row({
  row, actions, active, getControlTP,
}) {
  const checkOwner = ({
    onRowChange, e, rowId, v,
  }) => {
    onRowChange(e, rowId, {
      is_owner: v,
      part: 0,
    });
  };
  return (
    <TableRow
      key={row.id}
      onClick={(e) => actions.onActivateRow(e, row.id)}
      selected={active}
      hover
    >
      <TableCell>
        {getControlTP('member', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('relation', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('agro', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('is_owner', row.id, { callbackRow: checkOwner })}
      </TableCell>
      {/* {row.is_owner && ( */}
      <TableCell>
        {getControlTP('part', row.id, { readOnly: !row.is_owner })}
      </TableCell>
      {/* )} */}
    </TableRow>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    member: PropTypes.shape({ id: PropTypes.number, repr: PropTypes.string }),
    is_owner: PropTypes.bool,
  }).isRequired,
  fields: PropTypes.shape({
    member: PropTypes.shape({ read_only: PropTypes.bool, resource: PropTypes.string }),
  }).isRequired,
  actions: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onActivateRow: PropTypes.func.isRequired,
  }).isRequired,
  active: PropTypes.bool,
  errors: PropTypes.shape({ member: PropTypes.arrayOf(PropTypes.string) }),
  getControlTP: PropTypes.func.isRequired,
};

Row.defaultProps = {
  active: false,
  errors: null,
};

export default memo(Row);
